import * as angular from 'angular';

"use strict";

angular.module('BlocworxModule')
       .controller('CheckController', CheckController);

CheckController.$inject = ['$scope', 'ScopeAndLocal'];

function CheckController($scope, ScopeAndLocal) {

    let vm = this;

    /**
     * Constructor class.
     */
    vm.$onInit = function () {
        try {

        } catch (e) {
            console.log(e);
        }
    }
}

export default CheckController;